import { createRoute, useParams } from "@tanstack/react-router";
import i18n from "i18next";
import ReservationsAppleWalletPage from "../pages/reservations-apple-wallet";
import { rootRoute } from "./root";

export const reservationsAppleWalletRoute = createRoute({
  path: "/reservations/$hashedId/apple-wallet",
  getParentRoute: () => rootRoute,
  loader: () => i18n.loadNamespaces("transfer:apple-wallet"),
  component: function RouteComponent() {
    const { hashedId } = useParams({
      from: "/reservations/$hashedId/apple-wallet",
    });
    return <ReservationsAppleWalletPage hashedId={hashedId} />;
  },
});
